import React, { useEffect, useState } from 'react';
import { Col, Container, Nav, Navbar, NavDropdown, Row, Button } from 'react-bootstrap';
import { routes } from '../../routes';
import { Link } from 'react-router-dom';
import OurServicesController from '../../apis/controller/services.controller';
import Getin_touchmodal from '../../Views/Home/getin_touchmodal';

const TopNavbar = () => {
    const [scrolles, setScroll] = useState(false);
    const [show, setShow] = useState(false);
    const [servicesList, setServicesCategory] = useState();
    const [loader, setLoader] = useState(false);
    // constructor(props){
    //     super(props);
    //     this.state ={
    //         scrolles: false
    //     }
    // }
    // componentDidMount(){
    //     window.addEventListener("scroll", () => {
    //         this.setState({scrolles: window.scrollY > 50});
    //     });
    // }



    useEffect(() => {
        getServices()
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 50);
        });
    }, []);
    // render() {

    const getServices = async () => {
        setLoader(true);
        let res = await new OurServicesController().servicesCategories();
        if (res && res.status) {
            setServicesCategory(res.categories);
        }
        setLoader(false);
    };

    const closeModel = async () => {
        setShow(false)
    };

    return (
        <><div className={scrolles ? "top_navbar scrool" : "top_navbar "}>
            {servicesList && <Container>
                <Row>
                    <Col>
                        <div className="top_navbar_area d-lg-block d-none">
                            <Navbar collapseOnSelect expand="md">
                                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                                <Navbar.Collapse id="responsive-navbar-nav">
                                    <Nav className="mr-auto left_area">
                                        <Nav.Item>
                                            <Link to={routes.index}>Home</Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Link to={routes.about}>About us</Link>
                                        </Nav.Item>
                                        <NavDropdown title="Services" id="collasible-nav-dropdown">
                                            {servicesList.map((item, index) => (
                                                <NavDropdown key={index} className='sub' title={item.title} id={index}>
                                                    <> {item.services.map((item, index) => (
                                                        <NavDropdown.Item key={index} href={routes.service}>{item.title}</NavDropdown.Item>
                                                    ))}</>
                                                </NavDropdown>
                                            ))}
                                        </NavDropdown>
                                        <Nav.Item>
                                            <Link to={routes.product}>Products</Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Link to={routes.technologies}>Technologies</Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Link to={routes.packages}>Packages</Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Link to={routes.verticals}>Verticals</Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Link to={routes.hire}>Hire Resources</Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Link to={routes.career}>Careers</Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Link to={routes.contact}>Contact Us</Link>
                                        </Nav.Item>
                                    </Nav>
                                    <Nav className="right_area">
                                        <Nav.Item className="secondary_btn">
                                            {/* <Link to="#">Quick Contact</Link> */}
                                            <Button variant="outline-primary" onClick={() => setShow(true)}>Quick Contact</Button>
                                        </Nav.Item>
                                    </Nav>
                                </Navbar.Collapse>
                            </Navbar>
                        </div>
                    </Col>
                </Row>
            </Container>}
        </div><Getin_touchmodal show={show} closemodel={closeModel} /></>
    );
    // }
}

export default TopNavbar;